module.exports = __webpack_public_path__ + "img/home-active.5e043856.svg";